import { encryptedRequest, IResponse } from "../auth/api";
import { API_PATHS } from "../constants/api.constants";
import { createCacheAsync } from "@repo/shared-utils/common-utils";
import { logCprErrorToNewRelic } from "@repo/shared-utils/cpr-error-handler";

export type IApiResponse = {
  custType: string;
  city: string;
  firstName: string;
  lastName: string;
  gender: string;
  employmentType: string;
  annualIncome: string;
  custId: string;
  addressLine1: string;
  addressLine2: string;
  addressType: string;
  stateName: string;
  pinCode: string;
  reKycFlag: string;
  kycRenewalDate: string;
  multipleCustIds?: {
    city: string;
    custId: string;
    addressLine1: string;
    addressLine2: string;
    pinCode: string;
    firstName: string;
    lastName: string;
    indivCorpFlag: string;
    dob: string;
    panNo: string;
    gstNumber: string;
  }[];
  indivCorpFlag: string;
  panNo: string;
  dob: string;
  gstnNumber: string;
  email: string;
  rekycflag?: string;
  kycProcess?: string;
};

export type IApiRequest = {
  mobileNo: string;
  custId?: string;
};

const getUserDetailsApi = async (
  mobileNo: string,
  custId?: string
): Promise<IResponse<IApiResponse>> => {
  if (window.location.href.includes("initiate-tarsier-webview")) {
    return {
      data: {} as IApiResponse,
      statusCode: 90,
      status: "success",
      message: "Mocked response for initiate-tarsier-webview",
    };
  }
  const response = await encryptedRequest<IApiResponse, IApiRequest>({
    method: "POST",
    url: API_PATHS.userDetails,
    data: {
      mobileNo,
      custId,
    },
  });

  if (response.statusCode !== 90) {
    const errorCode = response.message?.split("|")[0]?.trim();
    const parsedErrorCode = errorCode ? Number.parseInt(errorCode, 10) : response.statusCode;
    logCprErrorToNewRelic(parsedErrorCode, response.statusCode, response.message, {
      apiName: "user-details",
    });
    throw new Error(response.message);
  }

  return response;
};

export const getUserDetails = async (
  mobileNo: string,
  custId?: string
): Promise<IResponse<IApiResponse>> => {
  const response = await createCacheAsync(
    `${API_PATHS.userDetails}-${mobileNo}-${custId}`,
    getUserDetailsApi,
    mobileNo,
    custId
  );
  if (!response) {
    throw new Error("Failed to fetch user details");
  }
  return response;
};

export const getUserDetailsWithoutWrapper = async (
  mobileNo: string,
  custId?: string
): Promise<IResponse<IApiResponse>> => {
  const response = await createCacheAsync(
    `${API_PATHS.userDetails}-${mobileNo}-${custId}`,
    getUserDetailsApi,
    mobileNo,
    custId
  );
  if (!response) {
    throw new Error("Failed to fetch user details");
  }
  return response;
};
